import { Component, HostListener, Input, OnInit } from "@angular/core";
import { ModalData } from "../../service/modal.service";
import { FormControl, FormGroup } from "@angular/forms";
import { BaseFormGroupService } from "./base-form-group.service";

@Component({
    template: "",
    standalone: false
})
export abstract class EntityModalComponent<Dto> implements OnInit {
  @Input() data?: ModalData<Dto>;

  public abstract formGroupService: BaseFormGroupService<Dto>;

  ngOnInit(): void {
    this.formGroupService.initFormGroup();
    if (this.data?.entity) {
      this.formGroupService.updateEntity(this.data?.entity);
    }
  }

  get formGroup(): FormGroup {
    return this.formGroupService.formGroup;
  }

  get entity(): Dto {
    return this.formGroupService.entity;
  }

  get submitted() {
    return this.formGroupService.submitted;
  }

  get editText(): string {
    return this.formGroupService.editText;
  }

  updateEntity(entity: Dto) {
    return this.formGroupService.updateEntity(entity);
  }

  onSubmit(close?: boolean) {
    return this.formGroupService.onSubmit(close);
  }

  saveIfDirty() {
    return this.formGroupService.saveIfDirty();
  }

  validityCheck() {
    return this.formGroupService.validityCheck();
  }

  dirtyCheck() {
    return this.formGroupService.dirtyCheck();
  }

  @HostListener("window:beforeunload", ["$event"])
  beforeUnloadHandler(event: BeforeUnloadEvent) {
    if (this.formGroup.dirty) {
      event.returnValue = "Neu laden nicht möglich";
    }
    return !this.formGroup.dirty;
  }

  @HostListener("document:keydown.escape", ["$event"]) onKeydownHandler(event: KeyboardEvent) {
    event.preventDefault();
    this.closeModal();
  }

  async reload() {
    return this.formGroupService.reload();
  }

  async closeModal() {
    return this.formGroupService.closeModal();
  }

  getControl(name: string): FormControl {
    return this.formGroup.get(name) as FormControl;
  }
}
